import { Service } from "../Service";

export class LoginService extends Service{
    
    constructor() {
        super('/');
    }

     login(nombreUsuario, contrasena) {
        
        var headers = {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "access-control-allow-origin": "*",
            "Access-Control-Allow-Headers": "Content-Type, Authorization",
        };
        
        return this.http.post(process.env.VUE_APP_API_BASE_URL + '/login', {nombreUsuario, contrasena}, {headers})
            .then((response) => {
                
                const config = {
                    "Authentication": "Bearer "+ response.data.Authorization
                }
                return config;
            })
            .catch((e) => {
                this.onError(e);
                return null;
            })
        

    }

    me() {
        return this.http.post(this.getUrlBase(['me']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
    }

}